<template>
  <div
    id="app"
    :style="'height:' + innerWH + 'px;background-color:' + innerColor + ';'"
  >
    <div
      class="app_content"
      :style="`height:${J.h_}px;width:${J.w_}px;`"
    >
      <!-- 模擬器 -->
      <img
        class="i_left_top"
        src="./assets/simulator/left_top.png"
      />
      <img
        class="i_top"
        src="./assets/simulator/top.png"
      />
      <img
        class="i_right_top"
        src="./assets/simulator/right_top.png"
      />

      <img
        class="i_left_center"
        src="./assets/simulator/left_center.png"
      />
      <img
        class="i_right_center"
        src="./assets/simulator/right_center.png"
      />
      <img
        class="i_left_long"
        src="./assets/simulator/left_long.png"
      />
      <img
        class="i_right_long"
        src="./assets/simulator/right_long.png"
      />
      <img
        class="i_left_bottom"
        src="./assets/simulator/left_bottom.png"
      />
      <img
        class="i_bottom"
        src="./assets/simulator/bottom.png"
      />
      <img
        class="i_right_bottom"
        src="./assets/simulator/right_bottom.png"
      />
      <!-- 導航欄 -->
      <div class="i_time_setting">
        <div
          class="i_time"
          v-text="nowTime"
        ></div>
        <img
          class="i_camera"
          src="./assets/simulator/camera.png"
        />
        <div class="i_setting">
          <img src="./assets/simulator/setting.png" />
        </div>
      </div>

      <!-- 模擬器背板 -->
      <div class="i_bg"></div>
      <div class="pc_body">
        <footNav></footNav>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import '@/style/iphone.css';
import footNav from '@/components/footNav';
import util from '@/js/util';
import { getBrandConfigList } from "./js/api";

export default {
  name: 'App',
  data () {
    return {
      innerWW: 0,
      innerWH: 0,
      innerColor: '#FFF',
      J: {},
      nowTime: ''
    };
  },
  components: {
    footNav
  },
  mounted () {
    var self = this;
    self.innerWW = window.innerWidth;
    self.innerWH = window.innerHeight;
    let J = util.getWindowInner()
    this.J = J;
    const href = location.href;
    if (href.indexOf('integral') > -1 || href.indexOf('coupon_detail') > -1) {
      self.innerColor = '#f5f5f5';
    }
    let hash = location.hash.split('/');
    let arg = hash[hash.length - 1];
    let brandId = util.getBrandStaticId({ arg: arg });
    getBrandConfigList({
      brandId: brandId,
      configNameList: "membershipSystemCheck"
    }).then(res => {
      const { data = [], success } = res;
      if (success) {
        if (data.length > 0) {
          // * 判斷 是啥
          let result = data[0] || {};
          if (!location.href.includes('noServer')) {
            if (result.valueInt == 0) {
              this.$router.replace({
                name: 'noServer',
                params: {
                  arg: arg
                }
              })
            }
          } else {
            if (result.valueInt == 1) {
              this.$router.replace({
                name: 'login',
                params: {
                  arg: arg
                }
              })
            }
          }
        }
      }
    });

    //判斷窗口大小
    // if(self.innerWW > 500){
    //   document.getElementById('app').style.width = '375px'
    // }
    document.body.style.backgroundColor = self.innerColor;
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      self.innerWW = window.innerWidth;
      self.innerWH = window.innerHeight;
    };

    if (util.IsPC()) {
      let
        w = J.w,
        h = J.h;
      document.querySelector("#app").classList.add("pc_app");
      document.body.classList.add('pbody');
      document.querySelector(".app_content").classList.add("pc_content");
      if (document.querySelector("#self_style")) {
        document.querySelector("#self_style").remove();
      }
      let style_ = document.createElement("style");
      style_.id = "self_style";
      let css_ = `
        .pc_content .self_intergral_recode .van-dropdown-item{width:${w}px;left:calc(50% - ${w / 2}px);}
      `;
      style_.textContent = css_;
      document.head.append(style_);
      // 設置 時間
      this.nowTime = new Date().getHours() + ':' + (new Date().getMinutes() + 1);
      setInterval(() => {
        this.nowTime = new Date().getHours() + ':' + (new Date().getMinutes() + 1);
      }, 60000)
    }
  },
  created () {
    console.log('this.$route.params----2', this.$route.params);
  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  background-repeat: no-repeat;
  background-size: cover;
}

#app {
  text-align: left !important;
}

img {
  content: normal !important;
}

.van-toast__text {
  word-break: break-word !important;
}

.self-content {
  padding: 0 16px !important;
}

.self_cell-title {
  font-size: 30px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 43px !important;
  margin-bottom: 0 !important;
  line-height: initial;
}

.cell-form .van-cell-group__title {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 15px !important;
  font-weight: 400;
  color: rgba(51, 51, 51, 1) !important;
}

.self_cell-desc {
  margin-top: 15px !important;
  margin-bottom: 0 !important;
  font-size: 13px !important;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
}

.self_cell-group_title_1 {
  margin-top: 39.5px !important;
}

.self_cell-group_title {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 15px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1) !important;
}

.self_cell-input {
  padding: 0 !important;
  margin: 15px 0 30px 0 !important;
  font-size: 17px !important;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
}

.self_cell-input:after {
  border-bottom: 0 !important;
}

input::-webkit-input-placeholder {
  color: rgba(204, 204, 204, 1) !important;
}

.cell-banner .van-image .van-image__error {
  position: inherit !important;
}

/* pc 適配 */
/* 最外層大框 */
.pc_app {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.pc_content {
  position: relative;
  position: relative;
  display: flex;
  justify-content: center;
}
.iphone {
  width: 100%;
  height: 100%;
  position: absolute;
  display: none;
}

/* 手機網頁內容體 */
.pc_body {
  height: 100%;
  position: relative;
}

.pc_content .pc_body {
  width: calc(100% - 54px);
  margin-top: 56px;
  height: calc(100% - 82px);
  background-color: #fff;
  z-index: 0;
}
.pc_content .iphone {
  display: block !important;
}

.pc_content .self_footnav,
.pc_content .self_membership_qrcode_mark,
.pc_content .van-overlay,
.pc_content .s-dialog_box,
.pc_content .self_nav-bar,
.pc_content .s-tab_box,
.pc_content .van-popup,
.pc_content .cell-footer {
  position: absolute !important;
}

/* pc 下的 內容主體 */
.pc_content .self_c {
  padding: 0;
  position: relative;
  height: 100% !important;
}

/* pc 下的 填充體 */
.pc_content .self_b {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  padding-top: 50px;
}

.pc_content .self_vipcard .self_b {
  height: calc(100% - 50px);
}

.pc_content .self_content_ {
  margin-top: 0 !important;
}

.pc_content .s-dialog_content .sex {
  font-size: 16px;
}

.pc_content .self_cell-swiper-box .van-swipe {
  overflow: auto;
}

.pc_content .self_restaurantDesc2 table {
  width: 100% !important;
}
</style>
<style lang="less" scoped>
.pc_content {
  * {
    & ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    & ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(88, 88, 88, 0.2);
      background: #a09f9f;
    }
    & ::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue